export const USERLIST = "admin/usersList";
export const USERDETAIL = "admin/userDetail";
export const USER_EVENT = "admin/event";
export const USER_SUB_EVENTS = "admin/event/subEvents";

export const USER_TASKS = "admin/event/tasks";
export const USER_DASHBOARD = "admin/user/dashboard"


export const POSTS = "admin/user/post";

export const JOB_CATEGORY_LIST = "admin/job/category";

export const SERVICE_CATEGORY_LIST = "admin/service/category";

export const JOB_POSTING_LIST = "admin/job";

export const FLAG_POSTING_LIST = "admin/report";

export const ACTIVE_FLAG_POSTING_LIST = "admin/report/post/active";

export const SERVICE_POSTING_LIST = "admin/service";

export const JOB_DETAILS = "admin/job/detail";

export const SERVICE_DETAILS = "admin/service/detail";

export const BLOCK_USER = "admin/user/blockUnblock";

export const PRICE = "admin/job-settings";

export const DASHBOARD = "admin/dashboard";


export const WAIT_LIST = "/admin/getWaitList"
export const FLAT_LIST = "/admin/getAds"
export const ADS_LIMIT = "/admin/setPostAdLimit"
export const USER_DETAIL = "/admin/userDetail"
export const CONTACT_US = "/admin/contactUsList"
export const UPLOAD_FILE = "/user/auth/upload"
export const EDIT_ADS = "/admin/editAd"
export const DELETED_USERS = "/admin/deleteUserList"
export const ADS_CITY = "/admin/getAdsByCity"
export const ADS_EXPORT_LIST = "/admin/getAdsExportList"


//usr roles
export const ROLE = "/admin/role";
export const ROLES = "/admin/roles";
// subadmins
export const SUBADMINS = "/admin/subadmins";
export const SUBADMIN = "/admin/subadmin";
export const USERPROFILE = "/admin/profile"

export const MIS = "/admin/misUsersList"
export const SAFETY_CHECK = "/admin/safetyCheckList"
export const REPORTED_CHATS = "/admin/reportUserList"
export const BLOCKED_CHATS = "/admin/blockUserList"
export const USER_CHAT = "/chat/chatAdmin"
export const RESET_PASSWORD = "/admin/resetSubAdminPassword"
export const EXPORT_WAITLIST = "/admin/exportWaitList"
export const LIFECYCLE = "/admin/getCompatibleInterestsUserList"
export const INTRESETED_ADS = "/admin/expressInterestAdList"
export const BOOKING_LIST = "/admin/bookingListByAdId"
export const EXPRESSED_INTEREST = "/admin/expressInterestListByAdId"
export const EXPORT_USER_LIST_DATA = "/admin/exportUsersListData";
export const EXPORT_SAFETY_CHECK_LIST = "/admin/exportSafetyCheckList";
export const EXPORT_EXPRESS_INTEREST_BOOKING_LIST = "/admin/exportExpressInterestBookingList";
export const FACE_VERIFY_PENDING_USER = "/admin/faceVerifyPendingUser";
export const VERIFY_USER = "/admin/actionOnUsersRequest"


